<div *ngIf="enableScrollBoxSentinel">
  <!-- Sentinel Element -->

  <!-- Scroll Down Box -->
  <div class="scroll-down-box" [ngClass]="{ 'fade-in': showScrollDownBox, 'fade-out': !showScrollDownBox }">
    <div class="mouse-icon">
      <!-- Mouse icon SVG -->
      <svg width="24" height="30" viewBox="0 0 24 36" xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink">
        <rect x="2" y="2" width="20" height="32" rx="10" ry="10" fill="none" stroke="currentColor" stroke-width="2" />
        <line x1="12" y1="8" x2="12" y2="14" stroke="currentColor" stroke-width="2" stroke-linecap="round">
          <animate xmlns="http://www.w3.org/2000/svg" attributeName="y2" values="14;8;14" dur="1.5s"
            repeatCount="indefinite" />
        </line>
      </svg>
    </div>
    <p>Scroll down</p>
  </div>
</div>

<div #scrollSentinel class="scroll-sentinel"></div>